import {Navigate, Route, Routes} from 'react-router-dom';
import DefaultLayout from './DefaultLayout';
import EmptyLayout from './EmptyLayout';
import { AuthProvider } from "../store/context/AuthContext";

import Home from '../pages/home/Home';
import JobCareApplyPage from '../pages/job/JobCareApplyPage';
import AnnouncementList from "../pages/announcement/AnnouncementList";
import FooterLayout from "./FooterLayout";
import OngoingTabPage from "../pages/announcement/OngoingTabPage";
import MatchingTabPage from "../pages/announcement/MatchingTabPage";
import CompletedTabPage from "../pages/announcement/CompletedTabPage";
import React from "react";
import HeaderLayout from "./HeaderLayout";
import CoordiListPage from "../pages/job/CoordiListPage";
import JobDetail from "../pages/job/JobDetail";
import CoordiDetailPage from "../pages/job/CoordiDetailPage";
import PaymentPage from "../pages/job/PaymentPage";
import TaskList from "../pages/task/TaskList";
import FindTaskPage from "../pages/task/FindTaskPage";
import MyTaskPage from "../pages/task/MyTaskPage";
import Wallet from "../pages/wallet/Wallet";
import ChargeListPage from "../pages/wallet/charge/ChargeListPage";
import RefundListPage from "../pages/wallet/refund/RefundListPage";
import UseListPage from "../pages/wallet/use/UseListPage";
import ProtectedRoute, {CoordinatorProtectedRoute, PaymentPasswordRoute} from './ProtectedRoute';
import LoginPage from "../pages/auth/LoginPage";
import SignupTermsPage from "../pages/auth/SignupTermsPage";
import SignupWriteDataPage from "../pages/auth/SignupWriteDataPage";
import ChargePage from "../pages/wallet/charge/ChargePage";
import RefundPage from "../pages/wallet/refund/RefundPage";
import AccountManagementPage from "../pages/wallet/account/AccountManagementPage";
import AccountVerification from "../pages/wallet/account/AccountVerification";
import ChargeDetailPage from "../pages/wallet/charge/ChargeDetailPage";
import UseDetailPage from "../pages/wallet/use/UseDetailPage";
import RefundDetailPage from "../pages/wallet/refund/RefundDetailPage";
import Menu from "../pages/mypage/Menu";
import MYInfo from "../pages/mypage/profile/MyInfo";
import SeniorList from "../pages/mypage/profile/SeniorList";
import SeniorDetailPage from "../pages/mypage/profile/SeniorDetailPage";
import SeniorAddPage from "../pages/mypage/profile/SeniorAddPage";
import AlarmListPage from "../pages/alarm/AlarmListPage";
import AlarmSettingPage from "../pages/alarm/AlarmSettingPage";
import JobHousekeepingApplyPage from "../pages/job/JobHousekeepingApplyPage";
import JobEscortApplyPage from "../pages/job/JobEscortApplyPage";
import MemberWithdrawal from "../pages/mypage/MemberWithdrawal";
import CoordinatorApplyPage from "../pages/mypage/coordinator/CoordinatorApplyPage";
import ChangePasswordPage from "../pages/mypage/profile/ChangePasswordPage";
import CoordinatorRouter from "../pages/mypage/coordinator/CoordinatorRouter";
import CoordinatorApplyDetailPage from "../pages/mypage/coordinator/CoordinatorApplyDetailPage";
import CoordinatorApplyDeniedPage from "../pages/mypage/coordinator/CoordinatorApplyDeniedPage";
import CoordinatorDetailPage from "../pages/mypage/coordinator/CoordinatorDetailPage";
import CoordinatorEditPage from "../pages/mypage/coordinator/CoordinatorEditPage";
import Settlement from "../pages/settlement/Settlement";
import FindIdPage from "../pages/auth/FindIdPage";
import ResetPasswordPage from "../pages/auth/ResetPasswordPage";
import FindPasswordPage from "../pages/auth/FindPasswordPage";
import LoginPasswordPage from "../pages/auth/LoginPasswordPage";
import LoginPasswordChangePage from "../pages/auth/LoginPasswordChangePage";
import FavoritePage from "../pages/mypage/FavoritePage";
import SettlementListPage from "../pages/settlement/SettlementListPage";
import WithdrawalListPage from "../pages/settlement/withdrawal/WithdrawalListPage";
import SettlementDetailPage from "../pages/settlement/SettlementDetailPage";
import WithdrawalDetailPage from "../pages/settlement/withdrawal/WithdrawalDetailPage";
import WithdrawalPage from "../pages/settlement/withdrawal/WithdrawalPage";
import NearbyShopPage from "../pages/mypage/nearby/NearbyShopPage";
import CompanyInfoPage from "../pages/mypage/CompanyInfoPage";
import ServiceApplyPage from "../pages/job/ServiceApplyPage";
import ShopDetailPage from "../pages/mypage/nearby/ShopDetailPage";
import PasswordPage from "../pages/auth/PasswordPage";
import TermsList from "../pages/terms/TermsList";
import TermsDetail from "../pages/terms/TermsDetail";
import SetPaymentPasswordPage from "../pages/auth/SetPaymentPasswordPage";
import NoticeListPage from "../pages/desk/NoticeListPage";
import NoticeDetailPage from "../pages/desk/NoticeDetailPage";
import FAQPage from "../pages/desk/FAQPage";
import InquiryPage from "../pages/desk/InquiryPage";
import QnAPage from "../pages/desk/QnAPage";
import QnAWritePage from "../pages/desk/QnAWritePage";
import QnADetailPage from "../pages/desk/QnADetailPage";
import QnAEditPage from "../pages/desk/QnaEditPage";
import FAQDetailPage from "../pages/desk/FaqDetail";
import {PaymentCallback} from "../pages/wallet/charge/PaymentCallback";
import JobDetailPage from "../pages/job/detail/JobDetailPage";
import JobDetailStandalone from "../pages/job/detail/JobDetailStandalone";
import ChangePaymentPassword from "../pages/mypage/profile/ChangePaymentPassword";
import PhoneChangePage from "../pages/mypage/profile/PhoneChangePage";
import ExpiredListPage from "../pages/wallet/expried/ExpiredListPage";
import ExpiredDetailPage from "../pages/wallet/expried/ExpiredDetailPage";
import {ChargeCallback} from "../pages/wallet/charge/ChargeCallback";
import AllListPage from "../pages/wallet/all/AllListPage";



const AppRouter = () => {
    return (
        <AuthProvider>
            <Routes>
                {/*  로그인 필요 영역 */}
                <Route element={<ProtectedRoute/>}>
                    {/* 뒤로가기&홈 있는 header + footer */}
                    <Route element={<DefaultLayout/>}>
                        <Route path="/announcement" element={<AnnouncementList/>}>
                            <Route index element={<Navigate to="matching" replace/>}/>
                            <Route path="matching" element={<MatchingTabPage/>}/>
                            <Route path="ongoing" element={<OngoingTabPage/>}/>
                            <Route path="completed" element={<CompletedTabPage/>}/>
                        </Route>
                        {/*코디전용 페이지*/}
                        <Route element={<CoordinatorProtectedRoute/>}>
                            <Route path="/task" element={<TaskList/>}>
                                <Route index element={<Navigate to="findTask" replace/>}/>
                                <Route path="findTask" element={<FindTaskPage/>}/>
                                <Route path="myTask" element={<MyTaskPage/>}/>
                            </Route>
                        </Route>
                        <Route path="/service-apply" element={<ServiceApplyPage/>}/>

                        <Route path="/wallet" element={<Wallet/>}>
                            <Route index element={<Navigate to="all-list" replace/>}/>
                            <Route path="all-list" element={<AllListPage/>}/>
                            <Route path="charge-list" element={<ChargeListPage/>}/>
                            <Route path="use-list" element={<UseListPage/>}/>
                            <Route path="refund-list" element={<RefundListPage/>}/>
                            <Route path="expired-list" element={<ExpiredListPage/>}/>
                        </Route>
                        <Route path="/settlement" element={<Settlement/>}>
                            <Route index element={<Navigate to="settlement-list" replace/>}/>
                            <Route path="settlement-list" element={<SettlementListPage/>}/>
                            <Route path="withdrawal-list" element={<WithdrawalListPage/>}/>
                        </Route>
                    </Route>

                    {/* 뒤로가기, 홈버튼 헤더만 있음 */}
                    <Route element={<HeaderLayout/>}>
                        <Route path="/service/apply/care" element={<JobCareApplyPage/>}/>
                        <Route path="/service/apply/escort" element={<JobEscortApplyPage/>}/>
                        <Route path="/service/apply/housekeeping" element={<JobHousekeepingApplyPage/>}/>
                        <Route path="/nearby/shop" element={<NearbyShopPage/>}/>
                        <Route path="/announcement/find/:jobPostingCode" element={<JobDetailStandalone/>}/>
                        <Route path="/announcement/:jobPostingCode" element={<JobDetail/>}>
                            <Route index element={<Navigate to="detail" replace/>}/>
                            <Route path="detail" element={<JobDetailPage/>}/>
                            <Route path="coordi" element={<CoordiListPage/>}/>
                        </Route>
                        <Route path="/announcement/:jobPostingCode/coordi/:coordinatorCode" element={<CoordiDetailPage/>}/>
                        <Route path="/coordinator/:coordinatorCode" element={<CoordiDetailPage/>}/>
                        {/*현재는 결제페이지 없어서 임시로 결제하기 전 페이지로 해놓음 결제비밀번호 퍼블도 아직 없음*/}
                        <Route element={<PaymentPasswordRoute/>}>
                            <Route path="/settlement/withdrawal" element={<WithdrawalPage/>}/>
                            <Route path="/wallet/charge" element={<ChargePage/>}/>
                            <Route path="/wallet/refund" element={<RefundPage/>}/>
                            <Route path="/wallet/accountManagement" element={<AccountManagementPage/>}/>
                        </Route>
                        <Route path="/payment" element={<PaymentPage/>}/>
                        

                        <Route path="/wallet/accountVerification" element={<AccountVerification/>}/>
                        <Route path="/wallet/charge-list/:id" element={<ChargeDetailPage/>}/>
                        <Route path="/wallet/use-list/:id" element={<UseDetailPage/>}/>
                        <Route path="/wallet/refund-list/:id" element={<RefundDetailPage/>}/>
                        <Route path="/wallet/expired-list/:id" element={<ExpiredDetailPage/>}/>
                        <Route path="/menu/myInfo/" element={<MYInfo/>}/>
                        <Route path="/menu/seniorList/" element={<SeniorList/>}/>

                        <Route path="/senior/:seniorCode" element={<SeniorDetailPage/>}/>
                        <Route path="/seniorAdd" element={<SeniorAddPage/>}/>
                        <Route path="/memberWithdrawal" element={<MemberWithdrawal/>}/>
                        <Route path="/menu/changePassword" element={<ChangePasswordPage/>}/>
                        <Route path="/mypage/phone-change" element={<PhoneChangePage/>}/>
                        <Route path="/menu/changePaymentPassword" element={<ChangePaymentPassword/>}/>
                        <Route path="/menu/coordinator" element={<CoordinatorRouter/>}/>
                        <Route path="/menu/favorite" element={<FavoritePage/>}/>
                        <Route path="/coordi/apply" element={<CoordinatorApplyPage/>}/>
                        <Route path="/coordi/apply/detail" element={<CoordinatorApplyDetailPage/>}/>
                        <Route path="/coordi/apply/denied" element={<CoordinatorApplyDeniedPage/>}/>
                        <Route path="/coordi/detail" element={<CoordinatorDetailPage/>}/>
                        <Route path="/coordi/edit" element={<CoordinatorEditPage/>}/>
                        {/*<Route path="/settlement/withdrawal" element={<WithdrawalPage/>}/>*/}
                        <Route path="/settlement/settlement-list/:id" element={<SettlementDetailPage/>}/>
                        <Route path="/settlement/withdrawal-list/:id" element={<WithdrawalDetailPage/>}/>
                        <Route path="/shop/:shopId" element={<ShopDetailPage/>}/>

                        <Route path="/terms/termsList" element={<TermsList/>}/>
                        <Route path="/terms/termsDetail" element={<TermsDetail/>}/>
                        <Route path="/desk/notice" element={<NoticeListPage/>}/>
                        <Route path="/desk/notice/:id" element={<NoticeDetailPage/>}/>


                        <Route path="/desk/inquiry" element={<InquiryPage/>}/>
                        <Route path="/desk/qna" element={<QnAPage/>}/>
                        <Route path="/desk/qna/write" element={<QnAWritePage/>}/>
                        <Route path="/desk/qna/:id" element={<QnADetailPage/>}/>
                        <Route path="/desk/qna/edit/:id" element={<QnAEditPage />} />
                        <Route path="/payment/callback" element={<PaymentCallback />} />
                        <Route path="/charge/callback" element={<ChargeCallback />} />
                    </Route>

                    <Route element={<EmptyLayout/>}>
                        <Route path="/payment-password" element={<PasswordPage/>}/>
                        <Route path="/alarmList" element={<AlarmListPage/>}/>
                        <Route path="/alarmSetting" element={<AlarmSettingPage/>}/>
                        <Route path="/login-password" element={<LoginPasswordPage/>}/>
                        <Route path="/login-password-change" element={<LoginPasswordChangePage/>}/>
                    </Route>
                </Route>

                {/*  로그인 없이 접근 가능 */}
                <Route element={<EmptyLayout/>}>
                    <Route path="/login" element={<LoginPage/>}/>
                    <Route path="/signup/terms" element={<SignupTermsPage/>}/>
                    <Route path="/signup/write" element={<SignupWriteDataPage/>}/>
                    <Route path="/find-id" element={<FindIdPage/>}/>
                    <Route path="/find-password" element={<FindPasswordPage/>}/>
                    <Route path="/reset-password" element={<ResetPasswordPage/>}/>
                    <Route path="/set-payment-password" element={<SetPaymentPasswordPage/>}/>
                    {/* Footer만 있음 */}
                    <Route element={<FooterLayout/>}>
                        <Route path="/" element={<Home/>}/>
                        <Route path="/menu" element={<Menu/>}/>
                    </Route>
                    {/*공지, 질문 회사 정보 여기에 추가 백단 securityConfig에 api 호출url도 넣어줘야함*/}
                    <Route element={<HeaderLayout/>}>
                        <Route path="/menu/company-info" element={<CompanyInfoPage/>}/>
                        <Route path="/desk/faq" element={<FAQPage/>}/>
                        <Route path="/faq/:seq" element={<FAQDetailPage />} />
                    </Route>
                </Route>
            </Routes>
        </AuthProvider>
    );
};

export default AppRouter;
